import { Mixpanel } from './mixpanel'

const REDIRECT_AFTER_LOGIN_KEY = 'mx-redirect-after-login'
const DEFAULT_POST_LOGIN_ROUTE = '/invest/companies'

// Shared post-login destination logic (was duplicated with slight drift
// across login/signup/authenticate/activate — unified on the fullest check).
// Returns '/on-boarding' when the profile is incomplete, else null (caller
// proceeds to its redirect target).
export const onboardingRouteFor = (user: any): string | null => {
  if (!user || user.isDeferredOnboarding) return null
  const profile = user.profiles?.[0]
  if (!profile) return '/on-boarding'
  const needsOnboarding =
    !user.firstName ||
    !user.lastName ||
    !profile.profileType ||
    ((profile.profileType === 'individual' ||
      profile.profileType === 'researching' ||
      profile.profileType === 'institutional' ||
      profile.profileType === 'family') &&
      (!profile.relevantInvestmentExperience ||
        !profile.willingnessToAcceptRisk ||
        !profile.targetSizePerInvestment ||
        !profile.networth)) ||
    ((profile.profileType === 'individual' ||
      profile.profileType === 'researching') &&
      !profile.accreditationStatus) ||
    profile.profileType === 'institutional' ||
    profile.profileType === 'family' ||
    (profile.profileType === 'shareholder' && !profile.shareHoldings)
  return needsOnboarding ? '/on-boarding' : null
}

const savedRedirectAfterLogin = (): string => {
  try {
    const saved = window.localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY)
    if (!saved) return ''
    const parsed = JSON.parse(saved)
    return typeof parsed === 'string' ? parsed : ''
  } catch {
    return ''
  }
}

interface CompletePostLoginParams {
  user: any
  email?: string
  activatedNow?: boolean
}

// Records the successful authentication before routing, preserves the old
// signup-conversion event only for newly activated signup accounts, and uses
// the same saved-destination behavior for code and magic-link verification.
export const completePostLogin = ({
  user,
  email,
  activatedNow = false,
}: CompletePostLoginParams): string => {
  Mixpanel.identify()
  Mixpanel.people.set({
    first_name: user?.firstName,
    last_name: user?.lastName,
    $email: email || user?.email,
  })
  if (activatedNow && user?.createdThrough === 'signup') {
    Mixpanel.track('Verify-Email')
  }

  const onboardingRoute = onboardingRouteFor(user)
  if (onboardingRoute) return onboardingRoute

  const redirectPath = savedRedirectAfterLogin() || DEFAULT_POST_LOGIN_ROUTE
  window.localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY)
  return redirectPath
}
